import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";

const EducationalQualification = ({setEducatuonalqualification}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const params = useParams();

  const getListDataById = async () => {
    setIsLoading(true);
    
    // Dummy data to replace API call
    const dummyData = [
      {
        _id: "1",
        Qname: "Class 12th",
        medium: "English",
        board: "CBSE",
        completedYear: "2020",
        percentage: "85%",
        institutionName: "Delhi Public School",
        marksheet: "https://example.com/marksheet1.pdf"
      },
      {
        _id: "2",
        Qname: "Bachelor of Science",
        medium: "English",
        board: "Delhi University",
        completedYear: "2023",
        percentage: "78%",
        institutionName: "St. Stephen's College",
        marksheet: "https://example.com/marksheet2.pdf"
      },
      {
        _id: "3",
        Qname: "Master of Education",
        medium: "English",
        board: "JNU",
        completedYear: "2024",
        percentage: "82%",
        institutionName: "Jawaharlal Nehru University",
        marksheet: "https://example.com/marksheet3.pdf"
      }
    ];
    
    setTimeout(() => {
      setIsLoading(false);
      setDataList(dummyData);
      if(dummyData.length > 0){
        setEducatuonalqualification(true);
      } else {
        setEducatuonalqualification(false);
      }
    }, 1000);
  };

  useEffect(() => {
    if (params.mid !== "") {
      getListDataById();
    }
  }, [params.mid]);

  const handleDownload = (url) => {
    const newWindow = window.open(url, '_blank');
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("Popup blocked. Please enable popups and try again.");
    }
  };

  return (
    <div>
      <div style={{ overflowX: "auto" }}>
        <Table hover>
          <thead>
            <tr style={{ background: "#F6F9FC" }}>
              <th id="tableheding">S.NO</th>
              <th id="tableheding">Class</th>
              <th id="tableheding">Medium</th>
              <th id="tableheding">Board</th>
              <th id="tableheding">Year of Completion</th>
              <th id="tableheding">Percentage Obtained</th>
              <th id="tableheding">School/University/College</th>
              <th id="tableheding">Marksheet</th>
            </tr>
          </thead>
          <tbody>
            {!isLoading ? (
              dataList.length > 0 ? (
                dataList.map((item, index) => (
                  <tr key={item._id} style={{ cursor: "pointer" }}>
                    <td id="tabledata">{index + 1}</td>
                    <td id="tabledata">{item?.Qname || "-"}</td>
                    <td id="tabledata">{item?.medium || "-"}</td>
                    <td id="tabledata">{item?.board || "-"}</td>
                    <td id="tabledata">{item?.completedYear || "-"}</td>
                    <td id="tabledata">{item?.percentage || "-"}</td>
                    <td id="tabledata">{item?.institutionName || "-"}</td>
                    <td id="tabledata">
                      <i
                        className="fa-solid fa-file"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDownload(item?.marksheet)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr style={{ textAlign: "center" }}>
                  <td colSpan="8" style={{ verticalAlign: "middle" }}>
                    No data found
                  </td>
                </tr>
              )
            ) : (
              <tr style={{ textAlign: "center" }}>
                <td colSpan="8" style={{ verticalAlign: "middle" }}>
                  Loading...
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <br />
    </div>
  );
};

export default EducationalQualification;
